import { useSite } from "@/context/SiteContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import Gallery from "@/components/Gallery";
import BeforeAfter from "@/components/BeforeAfter";
import QuoteCalculator from "@/components/QuoteCalculator";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingCall from "@/components/FloatingCall";

export default function Home() {
  const { content } = useSite();

  if (!content) {
    return (
      <div className="grain min-h-screen bg-brand-navy flex items-center justify-center">
        <div className="text-center">
          <div className="w-14 h-14 mx-auto rounded-full border-4 border-brand-blue border-t-brand-orange animate-spin" />
          <p className="mt-6 font-display uppercase tracking-widest text-white/60">CT Upholstery</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grain bg-brand-navy min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Stats />
        <Gallery />
        <BeforeAfter />
        <QuoteCalculator />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}
